import UsersList from './UsersList';

export const ROUTES = [
  {
    path: '/users',
    component: UsersList
  }
];
